import util from '../util'

let controller = 'ArquivoRetorno'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
  GetArquivosPendentesProcessamento: function () {
    return util.Axios.Get(controller + '/GetArquivosPendentesProcessamento')
  },
  ProcessarArquivo: function (dto) {
    return util.Axios.Post(controller + '/ProcessarArquivo', dto)
  }
})
